<template>
<div class="modal_wrapper">
  <div class='container'>
    <div class='modal_container'>
      <div class="modal_header">
        <img :src='caution' height=25px>
        {{confirm}}
      </div>
      <div class="modal_body">
        <div class="body" v-html='question'>
        </div>
        <div class="modal_buttons">
          <input type=button :value='cancelButton' class="cancel_button" @click="$emit('close')">
          <input type=button :value='importButton' class="finish_button" @click="$emit('import')">
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  data () {
    return {
      caution: require('../../img/caution.png'),
      confirm: '確認',
      question: 'インポートを行いますか？<br/>インポートする件数が多い場合は処理に数分かかる場合があります。',
      cancelButton: 'キャンセル',
      importButton: 'インポート'
    }
  }
}
</script>
<style scoped>
.modal_wrapper {
  background-color: rgba(0, 0, 0, .5);
}
.container {
  display: table-cell;
  vertical-align: middle;
}
.body {
  width: 100%;
  height: 117px;
  padding-top: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/modalWindow/importModalWindow.vue